(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/play-again.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/play-again.js');
"use strict";


const Payfooter = svs.tur.ReactPayfooter.Payfooter;
setGlobal('svs.tickets.play.components.PlayAgain', _ref => {
  let {
    handlePlayAgain,
    ticketInfo,
    hasUnscratchedTicket
  } = _ref;
  const productText = ticketInfo.active && ticketInfo.open ? "V\xE4lj ny ".concat(ticketInfo.name) : 'Välj ny lott';
  return React.createElement(Payfooter, {
    buttons: [{
      primary: true,
      text: hasUnscratchedTicket ? 'Oskrapade lotter' : productText,
      className: 'qa-play-again-btn',
      onClick: handlePlayAgain
    }]
  });
});

 })(window);